import { SALES_SIGNUP } from 'growth-onboarding-signup-redirect/constants/signupConstants';
import { Flow } from 'signup-constants/Flow';
import { Integration } from 'signup-constants/Integration';
import { Microapp } from 'signup-constants/Microapp';
import { getFlowKey } from '../routing/getFlowKey';
import { getIntegrationKey } from '../routing/getIntegrationKey';
import { getMicroappKey } from '../routing/getMicroappKey';
import { getTrialRedirect } from '../trial/getTrialRedirect';
import { isOauthFlow } from '../utils/oauthUtils';
import { getAcademyRedirect } from './academyRedirect';
import { getCMSDeveloperRedirect } from './cmsDeveloperRedirect';
import { getDirectoryListingRedirect } from './directoryListingRedirect';
import { getAssetProviderRedirect } from './getAssetProviderRedirect';
import { createAeoStandaloneRedirect } from './getAeoStandaloneRedirect';
import { getCommerceRedirect } from './getCommerceRedirect';
import { getFacebookCrmRedirect } from './getFacebookCrmRedirect';
import { getBlogIdeasGeneratorRedirect, getCampaignAssistantRedirect, getLandingPageCreatorRedirect, getMarketingEmailCreatorRedirect } from './getMicroappRedirect';
import { getOauthRedirect } from './getOauthRedirect';
import { getIntegratedAppRedirect, getWordPressRedirect } from './getIntegratedAppRedirects';
import { getHubSpotForStartupsRedirect, getHubSpotPartnersRedirect } from './hubspotForXRedirect';
import { getGoogleWorkspaceAppRedirect } from './getGoogleWorkspaceAppRedirect';
const SpecificRedirect = new Map([[Flow.Academy, getAcademyRedirect], [Flow.CmsDevelopers, getCMSDeveloperRedirect], [Flow.HubspotForStartups, getHubSpotForStartupsRedirect], [Flow.DirectoryListing, getDirectoryListingRedirect], [Flow.HubSpotPartners, getHubSpotPartnersRedirect], [Flow.FbCrm, getFacebookCrmRedirect], [Integration.Wordpress, getWordPressRedirect], [Integration.ShopifyEmbedded, getIntegratedAppRedirect], [Flow.Trial, getTrialRedirect], [Flow.AssetProvider, getAssetProviderRedirect], [Microapp.CampaignAssistant, getCampaignAssistantRedirect], [Microapp.BlogIdeasGenerator, getBlogIdeasGeneratorRedirect], [Microapp.LandingPageCreator, getLandingPageCreatorRedirect], [Microapp.MarketingEmailCreator, getMarketingEmailCreatorRedirect], [Flow.Commerce, getCommerceRedirect], [Integration.GoogleWorkspaceApp, getGoogleWorkspaceAppRedirect]]);
const SpecificEnrollment = new Map([[Flow.HubspotForStartups, SALES_SIGNUP]]);
function getFlowIntegrationOrMicroappKey() {
  const flowKey = getFlowKey();
  const integrationKey = getIntegrationKey();
  const microappKey = getMicroappKey();
  return microappKey || integrationKey || flowKey;
}
export const getSpecificRedirect = () => {
  const specificRedirect = SpecificRedirect.get(getFlowIntegrationOrMicroappKey());
  if (isOauthFlow()) {
    return getOauthRedirect;
  }
  if (getFlowKey() === Flow.AeoStandalone) {
    return createAeoStandaloneRedirect();
  }
  return specificRedirect;
};
export const getSpecificEnrollment = () => {
  return SpecificEnrollment.get(getFlowIntegrationOrMicroappKey());
};